module.exports = __webpack_public_path__ + "img/18.b01c54e8.jpg";